export default "__VITE_ASSET__BFA0Zxo1__"